import { ShieldCheck } from "lucide-react";
import { AnalyticsPreferenceControls } from "./AnalyticsConsentCard";
import { AI_EXPLANATION, ANALYTICS_COPY, APP_FOOTER_COPY, PRIVACY_COPY } from "../copy/disclaimers";
import { TermsContent } from "./TermsContent";

export function PrivacyDisclosure(): JSX.Element {
  return (
    <details className="privacy-disclosure" id="privacy-details">
      <summary>
        <ShieldCheck size={17} aria-hidden="true" />
        Privacy & report limits
      </summary>
      <div className="privacy-disclosure__body">
        <p>{PRIVACY_COPY}</p>
        <p>{AI_EXPLANATION}</p>
        <p>{ANALYTICS_COPY}</p>
        <p>{APP_FOOTER_COPY}</p>
        <AnalyticsPreferenceControls />
        <p><a href="/account/delete">Delete your MoveInReport account and cloud reports</a></p>
        <details className="terms-detail">
          <summary>Read detailed terms</summary>
          <TermsContent />
        </details>
      </div>
    </details>
  );
}
